import React, { useEffect, useState } from 'react'
import { Calendar2, Calendar2CheckFill } from 'react-bootstrap-icons'
import DateTimePickerFunctions from '../../../../components/ui/calendar/date_picket/DateTimePickerComponents/DateTimePickerFunctions'
import Dashboards from '../../../../libs/api/services/Dashboards'
import DashboardCardContainer from './DashboardCardContainer'
// import FlattenedHash from '../../../../libs/templating/FlattenedHash';

import FlattenedHash from '../../../../libs/templating/FlattenedHash'

export default function DashboardWidgetCalendar() {
  const [evntDetails, setEventDetails] = useState()
  useEffect(() => { _getUnreadMessageCount() }, [])
  const _getUnreadMessageCount = async () => {
    // No unread
    setEventDetails(await Dashboards.CalendarStatus().catch((e) => { console.error(e) }))
  }

  return (
    <DashboardCardContainer
      title={'Calender'}
      icon={<Calendar2CheckFill className='me-2' />}
      tail={[
        {
          icon: <Calendar2 className='me-2' />,
          description: 'View My Calendar',
          to: '/Dashboard/Calendar'
        }
      ]}
      breakdown={{
        properties: {
          template: `
            {{#calendars|confirmed}} <b>Confirmed</b>({{{.}}})&nbsp;{{/calendars|confirmed}} {{#calendars|tentative}} <b>Tentative</b>({{{.}}})&nbsp;{{/calendars|tentative}} {{#calendars|declined}} <b>Canceled</b>({{{.}}})&nbsp;{{/calendars|declined}}`,
          key: 'breakdown',
          filter: 'forDay',
          module: 'calendars'
        },
        options: Array.from({ length: 7 }).map((_, i) => {
          return {
            name: {
              0: 'Today',
              1: 'Tomorrow'
            }[i] || DateTimePickerFunctions.WEEKDAYS[DateTimePickerFunctions.addDays(new Date(), i).getDay()],
            offset: i,
            icon: undefined,
            value: i
          }
        })
      }}
      details={{
        component: <CalendarDetailsItems />
      }}
    />
    // <div className='col-lg-4 col-md-12 dashboard-card'>
    //   <div className='text-center bg-secondary-container p-3 rounded h-100 d-flex flex-column'>
    //     <div className='flex-shrink-1'>
    //       <h3><Calendar2CheckFill className='me-2' />Calender</h3>
    //     </div>
    //     <div className='flex-grow-1 d-flex flex-column justify-content-center align-items-center '>{evntDetails ? evntDetails.status : 'Checking your calendar'}</div>
    //     <div className='flex-shrink-1'>
    //       <NavLink
    //         key={'nav-cals'}
    //         className={"btn btn-sm"} tag={Link}
    //         //   to={menuItems[i].location}
    //         to={'/Dashboard/Calendar'}
    //       // onClick={(e) => _navigateTo(_menu.location)}
    //       >
    //         <button className='btn btn-sm'><Calendar2 className='me-2' />View My Calendar</button>
    //       </NavLink>
    //     </div>
    //   </div>
    // </div>
  )
}


const CalendarDetailsItems = ({ details, results }) => {
  const KEY = 'entries'
  if (!results || !Object.keys(results).includes(KEY)) return <></>

  const _handleShowDetails = () => { }
  return (<div>
    {results[KEY].map(entry => {
      const Flatten = new FlattenedHash(entry, 'item', {
        'item|status': (s) => { return s.toLowerCase() },
        'item|startDateTime': (s) => { return DateTimePickerFunctions.FancyHumanDT(new Date(s)) },
        'item|endDateTime': (s, o) => {
          return `for ${DateTimePickerFunctions.FancyHumanTimeDiff(new Date(o['item|startDateTime']), new Date(s))}`
        }
      })
      return (<div onClick={e => _handleShowDetails(entry.id)} className='my-2 bg-light text-dark small shadow p-1 rounded' key={entry.id}>
        {/* <pre>
          {JSON.stringify(Flatten.GetResult(), '\t', 2)}
        </pre> */}
        {
          Flatten.FromMustache(`
           {{item|startDateTime}} {{item|endDateTime}} {{item|summary}} {{item|status}} {{#item|location|facility}}at {{{.}}}{{/item|location|facility}} {{#item|patient|id}}with {{item|patient|firstName}} {{item|patient|lastName}} {{#item|clinician|id}}and {{item|clinician|firstName}} {{item|clinician|lastName}} {{/item|clinician|id}} {{/item|patient|id}}
           `)
        }
      </div>)
    })}
  </div >)
}